import './Characters.scss'

import { useCharacters } from "../../../contexts/Characters"
import { useEffect, useRef, useState } from 'react'
import { deepMatch } from '../../../utilities/helpers'
import { Roles } from '../../../utilities/constants'
import { Link, useNavigate } from 'react-router'
import Input from '../../forms/Input/Input'
import Select from '../../forms/Select/Select'
import koalition from '../../../api/koalition'
import { useToaster } from '../../../contexts/Toaster'

const Characters = () => {
    const navigate = useNavigate()
    const characters = useCharacters()
    const toaster = useToaster()
    const [visibleCharacters, setVisibleCharacters] = useState([])
    const [filterKey, setFilterKey] = useState()
    const [allianceFilter, setAllianceFilter] = useState()
    const [alliancesOptions, setAlliancesOptions] = useState([])
    const [advancedFiltersVisible, setAdvancedFiltersVisible] = useState(false)
    const [governorIdFilter, setGovernorIdFilter] = useState(undefined)

    const governorIdFilterOptions = [
        { value: undefined, label: 'Any' },
        { value: false, label: 'Without Governor Id' },
        { value: true, label: 'With Governor Id' },
    ]

    const filterVisibleCharacters = () => {
        if (characters.$state.server?.list) {
            const filteredCharacters = characters.$state.server[characters.authorized([Roles.developer, Roles.admin]) ? 'list' : 'accepted'].filter((character) => {
                const searchMatch = deepMatch(character.name, filterKey)
                const allianceMatch = allianceFilter === undefined || (allianceFilter === null && !character.alliance) || (character.alliance && allianceFilter && deepMatch(character.alliance.tag, allianceFilter))
                const governorIdMatch = governorIdFilter === undefined || (governorIdFilter === !!character.governorId)
                
                return searchMatch && allianceMatch && governorIdMatch
            })

            setVisibleCharacters(filteredCharacters)
        }
    }

    const onCharacterClick = (characterId) => {
        navigate(`/characters/${characterId}`)
    }

    const onUserClick = (event, userId) => {
        event.stopPropagation()
        navigate(`/users/${userId}`)
    }
    
    useEffect(() => {
        filterVisibleCharacters()
    }, [filterKey, allianceFilter, governorIdFilter, characters.$state])

    useEffect(() => {
        if (characters.$state.current) {
            koalition.get('/alliances').then((response) => {
                setAlliancesOptions([{ value: undefined, label: 'Any' }, ...response.data.map((alliance) => ({ value: alliance.tag, label: alliance.tag })), { value: null, label: 'No Alliance' }])
            }).catch((error) => {
                toaster.error(error)
                console.error(error)
            })
        }
    }, [characters.$state.current])

    return (
        <div className="container-fluid manage-characters">
            <div className="row">
                <div className="col col-xl-4 mb-3">
                    <Input onChange={setFilterKey} placeholder="Filter" />
                </div>
                <div className="col col-xl-4 mb-3 pl-0">
                    <Select options={alliancesOptions} filterFrom={false} onChange={setAllianceFilter} placeholder="Alliance" />
                </div>
                {characters.authorized([Roles.developer]) && (
                    <div className="col-auto pl-0">
                        <button className="primary medium icon" onClick={() => setAdvancedFiltersVisible(!advancedFiltersVisible)}>
                            <img src="/images/icons/filter.svg" />
                        </button>
                    </div>
                )}
            </div>
            {advancedFiltersVisible && (
                <div className="row">
                    <div className="col col-xl-4 mb-3">
                        <Select options={governorIdFilterOptions} onChange={setGovernorIdFilter} placeholder="Governor Id" />
                    </div>
                </div>
            )}
            <ul className="row mt-4 pr-4">
                {visibleCharacters.map((character) => (
                    <li className="col-sm-6 col-md-4 col-lg-3 pr-0" key={character._id}>
                        <div className="card character flex-center-y justify-content-between cursor-pointer mb-4" onClick={() => onCharacterClick(character._id)}>
                            {character.alliance && <span className="chip base aliance mr-3">{character.alliance?.tag}</span>}
                            <span className="mr-auto">{character.name}</span>
                            {characters.authorized([Roles.developer]) && (
                                <button className="primary small icon" onClick={(event) => onUserClick(event, character.user)}>
                                    <img src="/images/icons/person.svg" />
                                </button>
                            )}
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    )
}

export default Characters